export let CookieKeys = {
  XsrfToken: 'XSRF-TOKEN'
};

export interface IVizPortalCookies extends ng.cookies.ICookiesService {
}
